import styled from 'styled-components';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import { CardContent, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  mb15: {
    marginBottom: 15
  },
  mb10: {
    marginBottom: 10
  },
  mb30: {
    marginBottom: 30
  },
  ml15: {
    marginLeft: 15
  },
  ml30: {
    marginLeft: 30
  },
  pt50: {
    paddingTop: 50
  },
  pt0: {
    paddingTop: 0
  },
  pb0: {
    paddingBottom: 0
  },
  borderRadius10: {
    borderRadius: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    '&:first-child': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTop: '1px solid #e3ebf6'
    }
  },
  textLink: {
    cursor: 'pointer',
    color: '#2f68fd'
  },
  textDescription: {
    color: '#6e84a3',
    fontFamily: 'TTCommons',
    fontSize: 15,
    letterSpacing: 0,
    lineHeight: '18px',
    maxWidth: 858
  },
  buttonWrapper: {
    width: '113px'
  },
  completedIcon: {
    pointerEvents: 'none'
  },
  accordionRoot: {
    marginBottom: 20,
    '&:before': {
      height: '0px'
    },
    '&:last-child': {
      borderRadius: 15
    }
  }
});

export const CardContentWrapper = styled(CardContent)`
  height: 330px;
  overflow: auto;
`;

export const PhoneLink = styled.a`
  text-decoration: none;
  color: #2f68fd;
`;

export const ButtonGroupWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CenteredButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonText = styled.p`
  font-family: 'TTCommons';
  font-size: 15px;
  letter-spacing: 0;
  line-height: 18px;
  margin-left: 7px;
  padding-top: 5px;
`;

export const Title = styled.p`
  color: #12253f;
  font-family: 'TTCommons';
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  padding-top: 5px;
`;

export const FormItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  height: 53px;
  border-bottom: 1px solid #e3ebf6;
  align-items: center;
  &:last-child {
    border-bottom: none;
  }
`;

export const AccordionWrapper = styled(Accordion)`
  width: 60%;
  @media (max-width: 768px) {
    width: 100%;
  }
  
  @media (max-width: 1024px) {
    width: 100%;
  }
  box-shadow: none;
  border-radius: 15px;
  
  .MuiPaper-elevation1 {
    box-shadow: none;
  }

  .MuiAccordionSummary-root {
    height: 53px;

    &.Mui-expanded {
      min-height: 53px;
      height: 53px;
    }
  }

  .MuiCollapse-entered {
    height: auto;
    overflow-y: auto;
    max-height: 350px;
  }
`;

export const AccordionDetailsWrapper = styled(AccordionDetails)`
  padding: 0px;
`;

export const TypographyWrapper = styled(Typography)`
  font-family: 'TTCommons';
  color: #12253f;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
`;
